<div class="block-header">
  <div class="logo-box">
    <img class="logo-verizon">
    <p class="logo-box-text">
      Activate connectivity for
    </p>
    <p class="logo-box-text">
      your vehicle
    </p>
  </div>
  <div class="title-box">
    <h2 class="title">
      Connected Car powered by Verizon
    </h2>
  </div>
  <div class="description-box">
    <p class="description-line">Get unlimited connectivity (after 15GB premium speeds) powered by Verizon with plans starting at $20/mo.</p>
  </div>
  <app-main-button
    [backgroundColor]="'#FFFFFF'"
    [textColor]="'#000000'"
    [buttonText]="'Shop plans'"
    [myQueryParams] = "{mode: this.viewMode}"
    (onClick)="redirectSignIn()">
  </app-main-button>
</div>
<div class="block-content">
  <div *ngFor="let box of boxesText">
    <app-text-box
      [title]="box.title"
      [texts]="box.texts">
    </app-text-box>
  </div>
  <div class="button-box">
    <app-main-button
      [textColor]="'#FFFFFF'"
      [backgroundColor]="'#000000'"
      [buttonText]="'Shop plans'"
      [buttonWidth]="'92vw'"
      (onClick)="redirectSignIn()">
    </app-main-button>
  </div>
</div>
